(function () {
    // Factories and services affecting html input elements

    angular
        .module('app.ocom')
        .factory('focus', function ($rootScope, $timeout) {
            return function (name) {
                $timeout(function () {
                    console.log('Set focus...');
                    $rootScope.$broadcast('focusOn', name);
                });
            }
        })
})();